import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FinalCloseSection() {
  return <section className="bg-[#0D0D0D] text-center" style={{
    paddingTop: 'var(--space-section-lg)',
    paddingBottom: 'var(--space-section-lg)',
    paddingLeft: 'var(--pad-x)',
    paddingRight: 'var(--pad-x)'
  }} data-id="element-11">
      <div className="max-w-2xl mx-auto" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} data-id="element-13">
          <p className="text-[#9A948C] uppercase tracking-widest mb-6 fluid-sm" data-id="element-14">
            Una última pregunta
          </p>

          <h2 className="fluid-3xl font-serif text-white mb-8 leading-tight" data-id="element-15">
            ¿Cuántas veces más quieres regalar tu dignidad por{' '}
            <span className="text-[#A52422] italic" data-id="element-16">5 minutos de alivio</span>?
          </h2>

          <div className="space-y-4 text-[#F5F0EB]/90 mb-12 font-light fluid-xl" data-id="element-17">
            <p data-id="element-18">Si hoy tu dedo se va al chat…</p>
            <p data-id="element-19">si hoy sientes ese "solo una cosa"…</p>
            <p className="font-medium text-white" data-id="element-20">esto es para ti.</p>
          </div>

          <div id="comprar" className="bg-[#141210] p-6 sm:p-8 rounded-2xl border border-white/5 inline-block w-full max-w-md mx-auto" data-id="element-21">
            <img src="https://cdn.magicpatterns.com/uploads/9hKtgqhqQ9ywofceBUfJBz/heylloyd-image-1771269867266.png" alt="No Le Escribas PDF" className="w-[60%] max-w-[12rem] mx-auto mb-8 rounded shadow-2xl h-auto" style={{
            objectFit: 'contain'
          }} data-id="element-22" />
            <h3 className="fluid-2xl font-serif text-white mb-2" data-id="element-23">
              No Le Escribas
            </h3>
            <p className="text-[#9A948C] mb-8 fluid-base" data-id="element-24">
              Contacto Cero en 7 Días
            </p>

            <CTAButton fullWidth showPrice onClick={() => window.open('https://www.claridaddirecta.com/cart/57831466369405:1', '_blank')} data-id="element-25">
              Descargar Ahora
            </CTAButton>

            <p className="mt-4 text-[#9A948C] fluid-xs" data-id="element-26">
              Y cuando llegue la próxima ola, no improvises: <br data-id="element-27" />
              abre el protocolo y sigue el paso del día.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}